import TopicsPage from "./TopicsPage";

export default TopicsPage;
